import React from 'react';
import { Construction } from 'lucide-react';

const UnderConstruction = ({ pageName }) => {
  return (
    <div className="under-construction">
      <Construction size={64} className="under-construction-icon" />
      <h2 className="under-construction-title">{pageName}</h2>
      <p className="under-construction-text">This page is under construction.</p>
      <p className="under-construction-subtext">Check back soon for updates.</p>
    </div>
  );
};

export default UnderConstruction;
